























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component({
  name: 'Tabs',
  components: {
  }
})
export default class Tabs extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  loading!: boolean

  /**
   * @param {Number, String} value id
   * @description: 默认12酒套
   */
  @Prop({
    type: [String, Number],
    default: 12
  }) value!: string | number

  /**
   * @param {Number, String} value id
   * @description: 默认12酒套
   */
  @Prop({
    type: [String],
    default: ''
  }) isTop!: string

  /**
   * @param {array} list Tab数据
   * @description: 默认空数组
   */
  @Prop({
    type: Array,
    default: () => ([])
  }) list!: Array<any>

  // 更新v-model
  @Emit()
  input<T> (name: T): T {
    return name
  }

  // 触发change
  @Emit('change')
  changeItem () {
    return ''
  }

  dialogVisible = false

  // 激活索引
  get active (): number | string {
    return this.value
  }

  set active (newData: number | string) {
    this.input(newData)
    this.changeItem()
  }

  clickTabItem (id: number | string): void {
    if (this.loading) {
      this.$message({
        message: '数据加载中，请稍候...',
        type: 'warning'
      })
      return
    }
    this.active = id
  }
}
